import React from 'react'
import './HerosComponent.css'
import Hero from '../Classes/Hero'

const HerosComponent = ({ hero }) => {
    
    const allPoint = hero.allTimePoint ? hero.allTimePoint : 0
    const beforeSeasonPoint = allPoint - (hero.seasonPoint ? hero.seasonPoint : 0)
    const seasonPoint = hero.seasonPoint ? hero.seasonPoint : 0

    return (
        <div className='heroContainer' >
            <label for='bar'>
                {hero.name}
            </label>
            <div className='progressContainer'>
                <div className='allPoint'
                    style={{
                        backgroundColor: "#a7733f",
                        borderRadius: '100px 0px 0px 100px',
                        width: ((beforeSeasonPoint / Hero.LL_THRESHOLD) * 100) + "%",
                        textAlign: 'right',
                        zIndex: 10,
                    }}
                >
                    {beforeSeasonPoint}&nbsp;
                </div>
                <div className='seasonPoint'
                    style={{
                        backgroundColor: "#df9a55",
                        borderRadius: beforeSeasonPoint <= 0 ? '100px 0px 0px 100px' : '0px',
                        width: ((hero.seasonPoint / Hero.LL_THRESHOLD) * 100) + "%",
                        textAlign: 'right',
                    }}
                ></div>
                <div className='sapcing'
                    style={{
                        backgroundColor: "#df9a5500",
                        borderRadius: '100px 0px 0px 100px',
                    }}
                ></div>
            </div>
            <div
                className='addSeasonPoint'
                style={{
                    flex: 0.5,
                    marginRight: 5,
                }}
            >
                {seasonPoint > 0 ? '+' + seasonPoint : ''}
            </div>
        </div>
    )
}

export default HerosComponent


/*

                <progress id="bar" className='all'         max={hero.LL_THRESHOLD} value={allPoint}></progress>
                <progress id="bar" className='minusSeason' max={hero.LL_THRESHOLD} value={beforeSeasonPoint}></progress>
*/